import { useRouter } from 'next/navigation';
import { Button } from '@general';
import { Linking } from '@types';

import { LinkingItem } from '../linkingItem/LinkingItem';

import styles from './linkingsList.module.scss';

export interface LinkingItemsListProps {
	linkings: Linking[];
}

export const LinkingsList = ({ linkings }: LinkingItemsListProps) => {
	const router = useRouter();

	const navigateToContact = () => {
		router.push('/contact');
	};

	return (
		<div className={styles.wrapper} data-testid="linkingsList">
			<div className={styles[`linking-list`]}>
				<table aria-label="linking list">
					<thead>
						<tr
							className={styles[`linking-list-header`]}
							aria-label="linking list - header"
							data-testid="tableHeader"
						>
							<th>Title</th>
							<th>Date submitted </th>
							<th>Reference number </th>
							<th>Status </th>
						</tr>
					</thead>
					<tbody data-testid="linkingsTableBody">
						{linkings.map((linking, index) => (
							<LinkingItem linking={linking} key={index} />
						))}
					</tbody>
				</table>
			</div>
			<div className={styles['buttons-container']}>
				<Button
					ariaLabel="contact us"
					customStyles={styles.contact}
					type="primary"
					size="large"
					onClick={() => {
						navigateToContact();
					}}
				>
					Contact us
				</Button>
			</div>
		</div>
	);
};
